<button *ngFor="let lang of languages$ | async" (click)="onLanguageChosen(lang)"
        class="cursor-pointer"
        [class.active]="lang === selectedLang">
  {{lang.code}}
</button>
